import React, {Component} from 'react'
import {connect} from 'react-redux';
import {Card} from "components/Card/Card.jsx";
import {MdNavigateNext} from 'react-icons/md';
import SimpleReactValidator from 'simple-react-validator';
import {helperFunctions as HF} from 'helper/helperFunctions';
import {objectsConstants as OC} from 'redux/constant/objects-constant';
import $ from 'jquery';
import {FiKey} from 'react-icons/fi';
import {
    Grid,
    Row,
    Col,
    OverlayTrigger,
    Tooltip,
    Popover,
} from "react-bootstrap";
import {CSVReader} from 'react-papaparse';
import {Modal} from "react-bootstrap";
import ProductAttributeForm from './ProductAttributeForm';
import {SortableContainer, SortableElement, SortableHandle, arrayMove} from 'react-sortable-hoc';
import {withRouter} from 'react-router-dom';
import {brandActions} from '../../../redux/actions/brand-actions';
import {confirmAlert} from 'react-confirm-alert';
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import ToggleButton from "react-toggle-button";
import {themeCSSConstants} from 'redux/constant/themeCSS';
import DatePicker from "react-datepicker";
import ExcelReader from '../ExcelReader/ExcelReader';

let _ = require('lodash');
var cloneDeep = require('lodash.clonedeep');

const DragHandle = SortableHandle(() => <OverlayTrigger placement="bottom"
                                                        overlay={<Popover id="tooltip">Click and Hold to
                                                            Drag</Popover>}><span
    className="moveIcon orderDetailsAction "
></span></OverlayTrigger>);
const SortableItem = SortableElement((
    {
        value,
        onInputHandler,
        deleteConfirmListItem,
        onCheckFlag,
        fileType,
        onKeyClick,
        uniqueAttributes,
        sample_file_has_header,
        validatorData,
        keyAdded,
        returnTitleValidation,
        dateChangeHandler,
        view_mode,
    }) => (
    <tr test1={`innerItem-${value.key}`} key={`innerItem-${value.key}`}
        style={returnTitleValidation(value.value['db_column']) === 'has_header' ? null : {background: 'rgba(255,0,0,0.1)'}}>
        <td>{value.key + 1}</td>
        <td className="text-capitalize">
            <div className="flexElem" style={{wordBreak: 'break-all'}}>
                {
                    value.value['is_product_key'] === true ?
                        <OverlayTrigger placement="bottom"
                                        overlay={<Tooltip id={`key${value.key}`}>At least one key must be
                                            selected!</Tooltip>}>

                            <button
                                className="mr-xs yes keyBtn"
                                style={!keyAdded ? {color: '#ed2939'} : null}
                                onClick={() => {
                                    onKeyClick(true, value.key, 'is_product_key')
                                }}
                                disabled={view_mode}
                                onMouseEnter={() => false}
                            >
                                <FiKey/>
                            </button>
                        </OverlayTrigger>
                        :
                        <OverlayTrigger placement="bottom"
                                        overlay={<Tooltip id={`key${value.key}`}>At least one key must be
                                            selected!</Tooltip>}>
                            <button
                                className="mr-xs no keyBtn"
                                style={!keyAdded ? {color: '#ed2939'} : null}
                                onClick={() => {
                                    onKeyClick(false, value.key, 'is_product_key')
                                }}
                                disabled={view_mode}
                                onMouseEnter={() => false}
                            >
                                <FiKey/>
                            </button>
                        </OverlayTrigger>
                }
                {sample_file_has_header === true ?
                    value.value['title']
                    :
                    <span>
                            <input
                                type="text"
                                className="form-control"
                                name='title'
                                value={value.value['title']}
                                onChange={(e) => {
                                    onInputHandler(e, value.key)
                                }}
                                disabled={view_mode}
                            />
                        {validatorData.message('Title', value.key, 'required')}
                        </span>
                }
            </div>
        </td>
        <td style={{wordWrap: "break-word", wordBreak: "break-all", width: "10%"}}>
            {value.value['sample_value']}
        </td>
        <td>
            <input
                className="form-control text-capitalize"
                type="text"
                name='grid_label'
                value={value.value['grid_label'] ? value.value['grid_label'] : ''}
                onChange={(e) => {
                    onInputHandler(e, value.key)
                }}
                disabled={view_mode}
            />
        </td>
        {
            (fileType === 'FIXED_LENGTH' || value.value['start_position']) &&
            <React.Fragment>
                <td>
                    <input
                        type="text"
                        className="form-control"
                        name='start_position'
                        value={value.value['start_position']}
                        onChange={(e) => {
                            onInputHandler(e, value.key)
                        }}
                        disabled={view_mode}
                    />
                </td>
                <td>
                    <input
                        type="text"
                        className="form-control"
                        name='end_position'
                        value={value.value['end_position']}
                        onChange={(e) => {
                            onInputHandler(e, value.key)
                        }}
                        disabled={view_mode}
                    />
                </td>
            </React.Fragment>
        }
        <td>
                <span className={view_mode ? 'disabledToggle' : ''}>
                    <ToggleButton
                        inactiveLabel={''}
                        activeLabel={''}
                        colors={themeCSSConstants.THUMBICONSTYLE}
                        trackStyle={themeCSSConstants.TRACKSTYLE}
                        thumbStyle={themeCSSConstants.THUMBSTYLE}
                        thumbAnimateRange={[4, 30]}
                        value={value.value['show_on_grid']}
                        name="show_on_grid"
                        onToggle={(e) => onCheckFlag(e, value.key, 'show_on_grid')}
                    />
                </span>
        </td>
        <td>
            <OverlayTrigger placement="bottom"
                            overlay={<Tooltip id={`${value.key}`}>Changing this will effect order definition</Tooltip>}>
                    <span className={view_mode ? 'disabledToggle' : ''}>
                        <ToggleButton
                            inactiveLabel={''}
                            activeLabel={''}
                            colors={themeCSSConstants.THUMBICONSTYLE}
                            trackStyle={themeCSSConstants.TRACKSTYLE}
                            thumbStyle={themeCSSConstants.THUMBSTYLE}
                            thumbAnimateRange={[4, 30]}
                            value={value.value['is_quantity_attribute']}
                            name="is_quantity_attribute"
                            onToggle={(e) => onCheckFlag(e, value.key, 'is_quantity_attribute')}
                        />
                    </span>
            </OverlayTrigger>
        </td>
        <td>
            <OverlayTrigger placement="bottom" overlay={<Tooltip id={`${value.key}`}>Changing this will effect export
                attributes</Tooltip>}>
                    <span className={view_mode ? 'disabledToggle' : ''}>
                        <ToggleButton
                            inactiveLabel={''}
                            activeLabel={''}
                            colors={themeCSSConstants.THUMBICONSTYLE}
                            trackStyle={themeCSSConstants.TRACKSTYLE}
                            thumbStyle={themeCSSConstants.THUMBSTYLE}
                            thumbAnimateRange={[4, 30]}
                            value={value.value['exportable']}
                            name="exportable"
                            onToggle={(e) => onCheckFlag(e, value.key, 'exportable')}
                        />
                    </span>
            </OverlayTrigger>
        </td>
        <td>
                <span className={view_mode ? 'disabledToggle' : ''}>
                    <ToggleButton
                        inactiveLabel={''}
                        activeLabel={''}
                        colors={themeCSSConstants.THUMBICONSTYLE}
                        trackStyle={themeCSSConstants.TRACKSTYLE}
                        thumbStyle={themeCSSConstants.THUMBSTYLE}
                        thumbAnimateRange={[4, 30]}
                        value={value.value['searchable']}
                        name="searchable"
                        onToggle={(e) => onCheckFlag(e, value.key, 'searchable')}
                    />
                </span>
        </td>
        <td>
                <span className={view_mode ? 'disabledToggle' : ''}>
                    <ToggleButton
                        inactiveLabel={''}
                        activeLabel={''}
                        colors={themeCSSConstants.THUMBICONSTYLE}
                        trackStyle={themeCSSConstants.TRACKSTYLE}
                        thumbStyle={themeCSSConstants.THUMBSTYLE}
                        thumbAnimateRange={[4, 30]}
                        value={value.value['editable']}
                        name="editable"
                        onToggle={(e) => onCheckFlag(e, value.key, 'editable')}
                    />
                </span>
        </td>
        <td>
            <select
                onChange={(e) => onInputHandler(e, value.key)}
                className="form-control"
                name='data_type' value={value.value['data_type']}
                disabled={view_mode}
            >
                {
                    OC.dataTypeList.map((row, index) => (
                        <option value={row.value} key={index}> {row.label} </option>
                    ))
                }
            </select>
            {
                value.value['data_type'] === 'datetime' &&
                <select
                    onChange={(e) => onInputHandler(e, value.key)}
                    className="form-control mt-xs" name='date_format'
                    value={value.value['date_format'] ? value.value['date_format'] : ''}
                    required
                    disabled={view_mode}
                >
                    <option value="" selected hidden>Select Format</option>
                    {
                        OC.DATE_FORMATS.map((row, index) => (
                            <option value={row.value} key={index}> {row.label} </option>
                        ))
                    }
                </select>
            }

        </td>
        <td>
            {
                value.value['data_type'] === 'datetime' ?
                    <select
                        onChange={(e) => onInputHandler(e, value.key)}
                        className="form-control" name='default_value_type'
                        value={value.value['default_value_type'] ? value.value['default_value_type'] : ''}
                        disabled={view_mode}
                    >
                        <option value="" selected hidden>Select</option>
                        {
                            OC.DEFAULT_DATE_OPTIONS.map((row, index) => (
                                <option value={row.value} key={index}> {row.label} </option>
                            ))
                        }
                    </select>
                    :
                    <input
                        className="text-capitalize"
                        type="text"
                        className="form-control"
                        name='default_value'
                        value={value.value['default_value'] ? value.value['default_value'] : ''}
                        onChange={(e) => {
                            onInputHandler(e, value.key)
                        }}
                        disabled={view_mode}
                    />
            }
            {
                (value.value['default_value_type'] === 'pick_date' && value.value['data_type'] === 'datetime' && value.value['default_value_type']) &&
                <DatePicker
                    className="form-control mt-xs"
                    name='default_value'
                    selected={value.value['default_value'] ?
                        Date.parse(value.value['default_value'])
                        :
                        Date.now()}
                    onChange={(event) => dateChangeHandler(value.key, 'default_value', event)} autoComplete='off'
                    disabled={view_mode}
                />
            }

        </td>
        <td>
            <div style={{whiteSpace: 'nowrap'}}>
                <DragHandle/>
                <OverlayTrigger placement="bottom" overlay={<Popover id={`${value.key}`}>Delete Row</Popover>}>
                        <span>
                            <button
                                onClick={() => {
                                    deleteConfirmListItem(value.key)
                                }}
                                className={view_mode ? 'deleteIcon orderDetailsAction' : "deleteIcon orderDetailsAction"}
                                disabled={view_mode}
                            >&nbsp;</button>
                        </span>
                </OverlayTrigger>
                {
                    !value.value['db_column'] ?
                        returnTitleValidation(value.value['db_column']) !== 'has_header' ?
                            <OverlayTrigger placement="bottom"
                                            overlay={<Popover id={`${value.key}`}><b>Invalid Title!</b> Please delete
                                                this row or re-upload file.</Popover>}>
                                <i className="fa fa-exclamation-circle fa-lg" style={{color: 'red'}}></i>
                            </OverlayTrigger> :
                            <OverlayTrigger placement="bottom"
                                            overlay={<Popover id={`${value.key}`}>Title is required!</Popover>}>
                                <i className="fa fa-exclamation-circle fa-lg" style={{color: 'red'}}></i>
                            </OverlayTrigger>
                        : null
                }
            </div>
        </td>
    </tr>
));

const SortableList = SortableContainer(({
                                            brandProductAttributes,
                                            onInputHandler,
                                            deleteConfirmListItem,
                                            onCheckFlag,
                                            fileType,
                                            onKeyClick,
                                            uniqueAttributes,
                                            sample_file_has_header,
                                            validatorData,
                                            keyAdded,
                                            returnTitleValidation,
                                            setStickyReact,
                                            dateChangeHandler,
                                            view_mode
                                        }) => {
    return (
        <tbody>
        {
            brandProductAttributes.map((value, index) => (
                <SortableItem
                    key={`item-${index}`}
                    index={index}
                    value={{value: value, key: index}}
                    test={`item-${index}`}
                    onInputHandler={onInputHandler}
                    deleteConfirmListItem={deleteConfirmListItem}
                    onCheckFlag={onCheckFlag}
                    fileType={fileType}
                    onKeyClick={onKeyClick} uniqueAttributes={uniqueAttributes}
                    sample_file_has_header={sample_file_has_header} validatorData={validatorData}
                    keyAdded={keyAdded}
                    returnTitleValidation={returnTitleValidation}
                    dateChangeHandler={dateChangeHandler}
                    view_mode={view_mode}
                    disabled={view_mode}
                />
            ))
        }
        </tbody>
    );
});

const csvRef = React.createRef()

class BrandCSV extends Component {
    constructor(props) {
        super(props);
        this.fileInput = React.createRef();
        this.validatorData = new SimpleReactValidator({autoForceUpdate: this, locale: 'en'});
        this.state = {
            addModal: false,
            brand: {
                brand_id: ''
            },
            brand_product_attributes: this.props.fetchedProductAttributes ? this.props.fetchedProductAttributes.product_attributes ? this.props.fetchedProductAttributes.product_attributes : [] : [],
            fileType: '',
            data_definition: {
                start_position: '',
                end_position: '',
            },
            has_delimiter: false,
            sample_file_has_header: '',
            delimiter: null,
            type: this.props.fetchedProductAttributes ? 'edit' : '',
            fetchedProductsAdded: this.props.fetchedProductAttributes ? this.props.fetchedProductAttributes.product_attributes_added : -1,
            file_uploaded: false,
            previous_page: false,
            //isChanged property handles when the next button is disabled and enabled
            isChanged: false,
            quantity_length: [],
            export_length: [],
            sample_file_type: {},
            key: false,
            keyAdded: this.props.fetchedProductAttributes ? true : true,
            has_existing_file: false,
            discarded: false,
            productAdded: false,
            unmounting: true,
        }
    }

    onSortEnd = ({oldIndex, newIndex}) => {
        this.setState(({brand_product_attributes}) => ({
            brand_product_attributes: arrayMove(brand_product_attributes, oldIndex, newIndex),
        }));
    };

    handleReadCSV = (data) => {
        try {
            this.setState({
                ...this.state,
                sample_file_type: csvRef.current.inputFileRef.current.files[0],
                isChanged: true,
            })
            let product_attributes = [];
            if (data.length > 0) {
                let keys = Object.keys(data[0].data);
                for (let i = 0; i < keys.length; i++) {
                    product_attributes.push(
                        {
                            title: this.state.sample_file_has_header === true ? keys[i].trim() : '',
                            db_column: this.state.sample_file_has_header === true ? keys[i].replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '').replace(/\s+/g, '_').toLowerCase() : '',
                            grid_label: this.state.sample_file_has_header === true ? keys[i] : '',
                            sample_value: data[0].data[keys[i]],
                            start_position: null,
                            end_position: null,
                            show_on_grid: true,
                            is_quantity_attribute: false,
                            is_external_vendor_attr: false,
                            is_multiselect: false,
                            exportable: true,
                            searchable: false,
                            editable: false,
                            nullable: true,
                            import_order: Number(i) + 1,
                            data_type: HF.checkClosestDatatype(data[0].data[keys[i]]).value,
                            is_product_key: false,
                            default_value: '',
                            date_format: '',
                            default_value_type: null
                        }
                    )
                }
                this.setState(prevState => ({
                        brand_product_attributes: product_attributes,
                    })
                )
                //set the key true here
                setTimeout(() => {
                    this.setSticky();
                }, 100);
            }
        } catch (e) {
            this.warningMsg("The selected file is not a valid csv or txt file!");
        }

    }

    returnTitleValidation = (db_column) => {
        if (db_column && (this.state.sample_file_has_header || this.props.fetchedProductAttributes)) {
            return 'has_header';
        } else if (!db_column && !this.state.sample_file_has_header) {
            return 'has_header'
        } else if (db_column && !this.state.sample_file_has_header) {
            return 'has_header'
        } else {

        }
    }
    handleOnError = (err, file, inputElem, reason) => {
        console.log(err);
    }
    handleImportOffer = (e) => {
        this.fileInput.current.value = '';
        this.fileInput.current.click();
    }
    onInputHandler = (e, rowIndex) => {
        const atts = cloneDeep(this.state.brand_product_attributes);
        if (e.target.type === 'text' || e.target.type === 'select-one') {
            const {name, value} = e.target;
            if (name === 'title') {
                atts[rowIndex]['db_column'] = value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '').replace(/\s+/g, '_').toLowerCase();
            }
            if (name === 'data_type' || name === 'default_value_type') {
                atts[rowIndex]['default_value'] = '';
            }
            atts[rowIndex][name] = value;
        } else if (e.target.type === 'checkbox') {
            const {name, checked} = e.target;
            atts[rowIndex][name] = checked;
        }
        this.setState({brand_product_attributes: atts});
    }

    dateChangeHandler = (index, name, date) => {
        const atts = cloneDeep(this.state.brand_product_attributes);
        const updated_filter = atts[index];
        updated_filter['default_value'] = date;
        this.setState({
            brand_product_attributes: atts
        })
    }

    onKeyClick = (data, rowIndex, name) => {
        const atts = cloneDeep(this.state.brand_product_attributes);
        atts[rowIndex][name] = !data;
        this.setState({brand_product_attributes: atts});
    }

    handleAttributeSubmitForm = (data, formType) => {
        if (formType === 'save') {
            this.setState({
                brand_product_attributes: [
                    ...this.state.brand_product_attributes,
                    {
                        ...data,
                        import_order: this.state.brand_product_attributes.length + 1
                    }
                ],
                addModal: false
            }, () => {
                this.setSticky();
            })
        }
        if (formType === 'add_more') {
            this.setState({
                brand_product_attributes: [
                    ...this.state.brand_product_attributes,
                    {
                        ...data,
                        import_order: this.state.brand_product_attributes.length + 1
                    }
                ],
                addModal: true
            }, () => {
                this.setSticky();
            })
        }
    }

    deleteConfirmListItem = (id) => {
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <Confirmalertfordelete typeName="row" description={"Are you sure to delete this row"}
                                           onClosePro={onClose} deleteType={() => this.onDeleteAttribute(id)}/>
                )
            }
        })
    }
    warningMsg = (text = "") => {
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <Confirmalertfordelete typeName="row" msgType='warning' description={text} onClosePro={onClose}/>
                )
            }
        })
    }
    onDeleteAttribute = (key) => {
        const newAtts = this.state.brand_product_attributes.filter((data, index) => {
            return index !== key
        })
        this.setState({
            brand_product_attributes: newAtts
        })
    }

    onCheckFlag = (toggle, rowIndex, name) => {
        if (name === 'is_quantity_attribute') {
            this.setState({
                quantity_length: [
                    ...this.state.quantity_length,
                    rowIndex
                ]
            })
        }
        if (name === 'exportable') {
            this.setState({
                export_length: [
                    ...this.state.export_length,
                    rowIndex
                ]
            })
        }
        const atts = cloneDeep(this.state.brand_product_attributes);
        atts[rowIndex][name] = !toggle;
        this.setState({brand_product_attributes: atts});
    }

    setFileType(event) {
        const {value} = event.target;
        this.setState({
            ...this.state,
            fileType: value
        }, () => {
            this.state.fileType === 'TEXT' ? this.setState({has_delimiter: true}) : this.setState({
                has_delimiter: false
            })
        })
    }

    setHeader = (e) => {
        const {value} = e.target;
        value === 'true' ? this.setState({sample_file_has_header: true}) : this.setState({sample_file_has_header: false})
    }
    selectDelimiter = (e) => {
        this.setState({
            ...this.state,
            delimiter: e.target.value,
        })
    }
    setResourceFile = (key, value) => {
        this.setState({
            sample_file_type: value
        }, () => {
        });
    }
    onAttributesSubmit = () => {
        let obj;
        obj = {
            attributes_type: 'product',
            brand_attributes: JSON.stringify([...this.state.brand_product_attributes]),
            sample_file_has_header: this.state.sample_file_has_header ? this.state.sample_file_has_header : false,
            delimiter: this.state.delimiter,
            sample_file: this.state.sample_file_type,
            has_existing_file: this.state.has_existing_file,
        }

        // selected method start
        const {fileType} = this.state;
        if (fileType === 'EXCEL') {
            obj.selected_method = 'xlsx';
        } else if (fileType === 'CSV') {
            obj.selected_method = 'csv'
        } else if (fileType === 'TEXT') {
            obj.selected_method = 'txt'
        } else {
            obj.selected_method = null;
        }
        // selected method end

        // Setting properties when the attribtues have been saved once and are being fetched from backend
        if (this.props.fetchedProductAttributes) {
            if (this.props.fetchedProductAttributes.sample_file_path && this.state.discarded) {
                obj.has_existing_file = false;
                obj.delimiter = this.state.delimiter
            } else if (this.props.fetchedProductAttributes.sample_file_path) {
                obj.has_existing_file = true;
                obj.delimiter = this.props.fetchedProductAttributes.delimiter
                obj.sample_file_has_header = this.props.fetchedProductAttributes.sample_file_has_header
            } else if (this.props.fetchedProductAttributes.delimiter === 'rest' && !this.state.discarded) {
                obj.delimiter = this.props.fetchedProductAttributes.delimiter;
            }
        }
        // setting properties end
        if (this.state.delimiter === '\t') {
            obj.delimiter = 'tab';
        }
        if (!(obj.sample_file instanceof File)) {
            delete obj.sample_file
        }
        if (this.state.fileType === 'rest') {
            obj.delimiter = 'rest';
        }
        const formData = new FormData();
        for (const key in obj) {
            formData.append(key, obj[key]);
        }
        formData.append('_method', 'put');

        // Looping through the data to check if a key was selected
        let columns = 0;
        let end = 0;

        this.state.brand_product_attributes.forEach(data => {
            if (data.db_column) {
                columns += 1;
            }
            if (!data.is_product_key) {
                end += 1;
            }
        });
        //  check if key was selected
        if (end === this.state.brand_product_attributes.length) {
            this.setState({
                ...this.state,
                keyAdded: false,
                key: true
            })
            this.warningMsg("Please select at least one key")
            return;
        }
        if (columns === this.state.brand_product_attributes.length) {
            console.log('%c Success! ', 'background: #222; color: #bada55');
            this.props.storeBrandDataDefinitionCall(formData, this.props.storedBrand.id).then(res => {
                this.props.productAttsHandler(res.result.data_definition, this.state.quantity_length, this.state.export_length);
                this.setState({
                    file_uploaded: true,
                    isChanged: false,
                    discarded: false,
                    productAdded: true,
                }, () => {
                })
                if (res.result.data_definition.sample_file_path) {
                    this.setState({
                        has_existing_file: true
                    })
                }
            });
        }
    }
    uploadFileAgain = () => {
        // Method that sets the state to initial state in case when the user discards a file
        this.setState({
            addModal: false,
            brand: {
                brand_id: ''
            },
            brand_product_attributes: [],
            fileType: '',
            data_definition: {
                start_position: '',
                end_position: '',
            },
            has_delimiter: false,
            sample_file_has_header: '',
            delimiter: null,
            sample_file_type: {},
            has_existing_file: false,
            discarded: true,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(this.state.brand_product_attributes, prevState.brand_product_attributes) && (this.state.brand_product_attributes.length > 0 && this.state.isChanged === false)) {
            this.setState({
                isChanged: true,
            })
        }
        if (!_.isEqual(this.state.brand_product_attributes, prevState.brand_product_attributes) && this.state.key) {
            let end = 0;
            this.state.brand_product_attributes.forEach((item, index) => {
                if (!item.is_product_key) {
                    end += 1;
                }
            })
            if (end === this.state.brand_product_attributes.length) {
                this.setState({
                    keyAdded: false
                })
            } else {
                this.setState({
                    keyAdded: true
                })
            }
        }
    }

    setSticky = () => {
        if ($(".theme_table").hasClass("stickyHeader")) {
            $(".stickyTarget").width($(".stickyHeader").outerWidth());
            let rowCount = 0;
            $(".stickyHeader th").each(function () {
                $(".stickyTarget th:eq(" + rowCount + ")").width($(this).width());
                rowCount++;
            });

            $(".sidebar").hasClass("showSideNav") ?
                $(".stickyTarget").css("left", ($(".stickyHeader").offset().left - 45))
                :
                $(".stickyTarget").css("left", "50px")
        }
    }

    componentDidMount() {
        let that = this;
        if (this.props.fetchedProductAttributes) {
            if (this.props.fetchedProductAttributes.product_attributes_added === 0) {
                this.setState({
                    isChanged: true
                })
            }
            setTimeout(function () {
                if (that.props.fetchedProductAttributes.product_attributes.length > 0) {
                    that.setSticky();
                }
            }, 500)
        }
        try {
            if ($('input:file').length) {
                $('input:file').removeAttr('accept')
            }
        } catch (e) {
            console.log('error in removing accept attribute from readers')
        }
    }

    handleExcelAttributes = (data, file_type) => {
        if (data.length > 0) {
            this.setState({
                brand_product_attributes: data,
                sample_file_type: file_type,
            })
        }
    }

    render() {
        const {brand_product_attributes} = this.state;
        const {view_mode} = this.props;
        const that = this;
        if (($(".theme_table").hasClass("stickyHeader")) && that.state.unmounting) {
            $(window).resize(function () {
                if ($(".theme_table").hasClass("stickyHeader")) {
                    that.setSticky();
                }
            });

            $(window).scroll(function () {
                if ($(".theme_table").hasClass("stickyHeader")) {
                    if ($(this).scrollTop() >= $(".stickyHeader").offset().top) {
                        $(".stickyTarget").fadeIn("fast");
                    } else {
                        $(".stickyTarget").fadeOut("fast");
                    }
                }
            });
        }
        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                className="mt-lg"
                                ctTableResponsive
                                content={
                                    <div>
                                        <Grid fluid>
                                            <Row>
                                                <Col md={12}>
                                                    {
                                                        brand_product_attributes.length === 0 &&
                                                        <h3 style={{textAlign: 'center', fontWeight: "500"}}>Product /
                                                            Style Data Definition</h3>
                                                    }

                                                    {
                                                        brand_product_attributes.length > 0 &&
                                                        <h3 style={{textAlign: 'center', fontWeight: "500"}}>Manage
                                                            Product / Style Data Definition</h3>
                                                    }
                                                </Col>

                                                <div className="col-md-8 col-md-offset-2">
                                                    {
                                                        brand_product_attributes.length === 0 &&
                                                        <div className="mt-lg text_16">
                                                            Define brand product/style data by uploading a sample CSV or
                                                            excel file. A few rules to follow.
                                                            <ol className="blackNumber">
                                                                <li>The first row shall contain data/column header</li>
                                                                <li>Do not leave empty column header</li>
                                                                <li>Do not leave empty rows between data rows</li>
                                                                <li>Put max possible sample value for each data column
                                                                    to accomodate
                                                                </li>
                                                            </ol>
                                                            <div>
                                                                <div className="text_18 mt-xlg"><strong>Select
                                                                    Method: </strong></div>

                                                                <div onChange={this.setFileType.bind(this)}>
                                                                    {
                                                                        OC.data_definition_formats.map((data, index) => {
                                                                            return (
                                                                                <div key={index} className="mt-sm">
                                                                                    <label
                                                                                        className="container-radio">
                                                                                        <input type="radio"
                                                                                               value={data.key}
                                                                                               name="fileType"/>
                                                                                        <span
                                                                                            className="checkmark"></span>
                                                                                        {data.label}
                                                                                    </label>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                            <hr className="medium"/>
                                                            {
                                                                (this.state.fileType === 'CSV' || (this.state.fileType === 'TEXT' && this.state.has_delimiter === true) || this.state.fileType === 'EXCEL') &&

                                                                <div className="col-md-6">
                                                                    <div>Does your file contain a header?</div>
                                                                    <div onChange={this.setHeader} required>
                                                                        <label
                                                                            className="container-radio mt-sm">
                                                                            <input type="radio" value="true"
                                                                                   name="has_header"/>
                                                                            <span className="checkmark"></span>
                                                                            Yes
                                                                        </label>

                                                                        <label
                                                                            className="container-radio mt-sm ml-xlg">
                                                                            <input type="radio" value="false"
                                                                                   name="has_header"/>
                                                                            <span className="checkmark"></span>
                                                                            No
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                this.state.fileType === 'TEXT' &&
                                                                <div className="col-md-6">
                                                                    <select name="delimiter" className="form-control"
                                                                            onChange={this.selectDelimiter}
                                                                            defaultValue="">
                                                                        <option value="" disabled hidden>Choose
                                                                            Delimiter
                                                                        </option>
                                                                        {
                                                                            OC.data_definition_delimiters.map((data, index) => {
                                                                                return <option value={data.key}
                                                                                               key={index}>{data.label}</option>
                                                                            })
                                                                        }
                                                                    </select>
                                                                </div>

                                                            }
                                                        </div>
                                                    }
                                                </div>
                                                <div className="clearfix"></div>
                                                {
                                                    brand_product_attributes.length > 0 &&
                                                    <div id="brandDataTable table-responsive col-md-12">
                                                        <div className="mt-lg text_16">Data read from Sample File</div>
                                                        <table
                                                            className="table theme_table stickyHeader blank table-striped mt-md"
                                                            style={{width: '100%', tableLayout: 'fixed'}}>
                                                            <thead>
                                                            <tr>
                                                                <th>Order</th>
                                                                <th>Title</th>
                                                                <th>Sample Value</th>
                                                                <th>Grid Label</th>
                                                                {
                                                                    (this.state.fileType === 'FIXED_LENGTH' || this.state.brand_product_attributes[0].start_position) &&
                                                                    <React.Fragment>
                                                                        <th>Start Position</th>
                                                                        <th>End Position</th>
                                                                    </React.Fragment>
                                                                }
                                                                <th>Show On Order</th>
                                                                <th>QTY Attribute</th>
                                                                <th>Allow Export</th>
                                                                <th>Searchable</th>
                                                                <th>Editable</th>
                                                                <th>Data Type</th>
                                                                <th>Default Value</th>
                                                                <th>Control</th>
                                                            </tr>
                                                            </thead>
                                                            <SortableList
                                                                axis='xy'
                                                                brandProductAttributes={brand_product_attributes}
                                                                helperClass="movingTr"
                                                                onSortEnd={this.onSortEnd}
                                                                onInputHandler={this.onInputHandler}
                                                                deleteConfirmListItem={this.deleteConfirmListItem}
                                                                onCheckFlag={this.onCheckFlag}
                                                                fileType={this.state.fileType}
                                                                onKeyClick={this.onKeyClick}
                                                                uniqueAttributes={this.state.unique_values}
                                                                sample_file_has_header={this.state.sample_file_has_header}
                                                                validatorData={this.validatorData}
                                                                keyAdded={this.state.keyAdded}
                                                                returnTitleValidation={this.returnTitleValidation}
                                                                setStickyReact={this.setStickyReact}
                                                                dateChangeHandler={this.dateChangeHandler}
                                                                useDragHandle
                                                                view_mode={this.props.view_mode}
                                                            />
                                                        </table>
                                                    </div>
                                                }
                                                {/* Add Order Attribute */}
                                                {
                                                    <Modal bsSize="full" show={this.state.addModal}
                                                           onHide={HF.closeModal.bind(this, "addModal")}
                                                           aria-labelledby="ModalHeader"
                                                    >
                                                        <Modal.Header closeButton>
                                                            <Modal.Title id='ModalHeader' className="headerTitle">Add
                                                                Product Attributes</Modal.Title>
                                                        </Modal.Header>
                                                        <Modal.Body>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <ProductAttributeForm
                                                                        closeModel={HF.closeModal.bind(this, "addModal")}
                                                                        formTypePro="add"
                                                                        brandPro={(this.state.fileType === 'FIXED_LENGTH' ||
                                                                            (!_.isEmpty(this.state.brand_product_attributes)
                                                                                ?
                                                                                this.state.brand_product_attributes[0].start_position : false)) ?
                                                                            {...OC.brand_product_attributes, ...this.state.data_definition}
                                                                            :
                                                                            OC.brand_product_attributes}
                                                                        handleSubmit={this.handleAttributeSubmitForm}
                                                                        fileType={this.state.fileType}
                                                                        start_condition={(!_.isEmpty(this.state.brand_product_attributes) ? this.state.brand_product_attributes[0].start_position : false)}
                                                                        attributesProp={brand_product_attributes}
                                                                        name={this.props.title}
                                                                        componentPro={'Brand'}
                                                                        listDataProp={this.state[this.props.title + '_data']}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </Modal.Body>
                                                    </Modal>
                                                }
                                                {
                                                    <div className="col-md-12 text-center mt-md mb-lg">
                                                        {
                                                            this.state.brand_product_attributes.length > 0 && !view_mode &&
                                                            <button onClick={this.uploadFileAgain}
                                                                    className="customBtn btnRed ml-sm mr-sm">Discard And
                                                                Re-upload File</button>
                                                        }
                                                        {
                                                            this.state.brand_product_attributes.length > 0 && !view_mode && this.state.previous_page &&
                                                            <button className="customBtn btnBlue ml-sm mr-sm"
                                                                    onClick={this.props.history.goBack}>Go Back</button>
                                                        }
                                                        {
                                                            (this.state.brand_product_attributes.length > 0 || this.state.fileType === 'FIXED_LENGTH' || this.state.fileType === 'rest') && !view_mode &&
                                                            <button className="customBtn btnBlack ml-sm mr-sm"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            addModal: true,
                                                                        })
                                                                    }}>Add Attribute</button>
                                                        }
                                                        {
                                                            this.state.brand_product_attributes.length > 0 && !view_mode &&
                                                            <button className="customBtn btnBlue ml-sm mr-sm"
                                                                    onClick={this.onAttributesSubmit}
                                                                    disabled={this.state.isChanged ? false : true}>Save
                                                                Updates</button>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    this.state.fileType === 'CSV' && this.state.brand_product_attributes.length === 0 && !view_mode &&
                                                    <div className="text-center col-md-12 mb-xlg">
                                                        <div className="customDrop"><CSVReader
                                                            onDrop={this.handleReadCSV}
                                                            onError={this.handleOnError}
                                                            addRemoveButton
                                                            removeButtonColor='#659cef'
                                                            onRemoveFile={this.handleOnRemoveFile}
                                                            ref={csvRef}
                                                            accept={'text/csv, .csv, application/vnd.ms-excel, .txt'}
                                                            style={{display: 'none'}}
                                                            config={{
                                                                skipEmptyLines: true,
                                                                delimiter: this.state.delimiter,
                                                                header: this.state.sample_file_has_header
                                                            }}
                                                        >
                                                            <button className="customBtn btnBlue">Upload CSV File</button>
                                                        </CSVReader></div>
                                                    </div>
                                                }
                                                {
                                                    this.state.fileType === 'EXCEL' && this.state.brand_product_attributes.length === 0 && !view_mode &&
                                                    <div className="text-center mb-xlg">
                                                        <ExcelReader
                                                            sample_file_has_header={this.state.sample_file_has_header}
                                                            returnExcelAtts={this.handleExcelAttributes}
                                                        />
                                                    </div>
                                                }
                                                {
                                                    this.state.fileType === 'TEXT' && this.state.delimiter && this.state.brand_product_attributes.length === 0 && !view_mode &&
                                                    <div className="text-center col-md-12 mb-xlg">
                                                        <div className="customDrop"><CSVReader
                                                            onDrop={this.handleReadCSV}
                                                            onError={this.handleOnError}
                                                            addRemoveButton
                                                            removeButtonColor='#659cef'
                                                            onRemoveFile={this.handleOnRemoveFile}
                                                            ref={csvRef}
                                                            accept={'text/csv, .csv, application/vnd.ms-excel, .txt'}
                                                            style={{display: 'none'}}
                                                            config={{
                                                                skipEmptyLines: true,
                                                                delimiter: this.state.delimiter,
                                                                header: this.state.sample_file_has_header
                                                            }}
                                                        >
                                                            <button className="customBtn btnBlue">Upload TEXT File</button>
                                                        </CSVReader></div>
                                                    </div>
                                                }
                                            </Row>
                                        </Grid>
                                    </div>
                                }
                            />
                            <div className="stepsNav">
                                {
                                    // Works when the wizard is being edited
                                    ((this.state.brand_product_attributes.length > 0 && this.state.productAdded) || (this.state.fetchedProductsAdded == 1)) && !view_mode &&
                                    <div className="text-center">
                                        <button onClick={this.props.nextStep} className="stepNav next"
                                                disabled={!this.state.isChanged ? false : true}><MdNavigateNext/>
                                        </button>
                                        <span className="display_ib mt-xs">Next</span>
                                    </div>
                                }
                            </div>
                            <div className="stepsNav">
                                {
                                    // When in view mode
                                    view_mode &&
                                    <div className="text-center">
                                        <button onClick={this.props.nextStep} className="stepNav next"><MdNavigateNext/>
                                        </button>
                                        <span className="display_ib mt-xs">Next</span>
                                    </div>
                                }
                            </div>
                            {
                                brand_product_attributes.length > 0 &&
                                <table className="table theme_table stickyTarget blank table-striped mt-md">
                                    <thead>
                                    <tr>
                                        <th>Order</th>
                                        <th>Title</th>
                                        <th>Sample Value</th>
                                        <th>Grid Label</th>
                                        {
                                            (this.state.fileType === 'FIXED_LENGTH' || this.state.brand_product_attributes[0].start_position) &&
                                            <React.Fragment>
                                                <th>Start Position</th>
                                                <th>End Position</th>
                                            </React.Fragment>
                                        }
                                        <th>Show On Order</th>
                                        <th>QTY Attribute</th>
                                        <th>Allow Export</th>
                                        <th>Searchable</th>
                                        <th>Editable</th>
                                        <th>Data Type</th>
                                        <th>Default Value</th>
                                        <th>Control</th>
                                    </tr>
                                    </thead>
                                </table>
                            }
                            {
                                view_mode &&
                                <div className="text-center">
                                    <button
                                        className="customBtn btnBlue m-md"
                                        type='button'
                                        onClick={() => {
                                            this.props.history.goBack()
                                        }}
                                    >Go Back
                                    </button>
                                </div>
                            }
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return ({
        storeBrandCall: (brandData) => {
            return dispatch(brandActions.storeBrand(brandData))
        },
        storeBrandProductAttsCall: (brandData, id) => {
            return dispatch(brandActions.storeBrandProductAtts(brandData, id))
        },
        storeBrandDataDefinitionCall: (data, id) => {
            return dispatch(brandActions.storeBrandDataDefinition(data, id))
        }
    });
};

function mapStateToProps(state, ownProps) {
    const {brand} = state.brandReducer;
    return {
        brand,
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BrandCSV));



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/BrandCSV.jsx